import {SET_ITEM_PROPERTIES} from "../actions/itemPropertiesActions";

export default function (state = [], action) {
    switch (action.type) {
        case SET_ITEM_PROPERTIES:
            return [...action.itemProperties];
        default:
            return state;
    }
}